import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useSearchParams } from 'react-router-dom';
import { CheckCircle2, Info, Loader2, XCircle } from 'lucide-react';

const INITIAL = {
  status: 'processing',
  title: 'Recording your decision',
  message: 'Applying this leave decision.',
  action: null,
};

function iconFor(status, action) {
  if (status === 'processing') {
    return <Loader2 className="h-14 w-14 text-primary-600 animate-spin" aria-hidden="true" />;
  }
  if (status === 'success' && action === 'approved') {
    return <CheckCircle2 className="h-14 w-14 text-green-600" aria-hidden="true" />;
  }
  if (status === 'success' && action === 'declined') {
    return <XCircle className="h-14 w-14 text-red-600" aria-hidden="true" />;
  }
  if (status === 'already') {
    return <Info className="h-14 w-14 text-primary-600" aria-hidden="true" />;
  }
  return <XCircle className="h-14 w-14 text-red-600" aria-hidden="true" />;
}

const LeaveEmailAction = () => {
  const [searchParams] = useSearchParams();
  const [result, setResult] = useState(INITIAL);

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setResult({
        status: 'error',
        title: 'This link is invalid or expired',
        message: 'This approval link is no longer valid.',
        action: null,
      });
      return;
    }

    let cancelled = false;
    axios
      .post('/api/leaves/email-action', null, {
        params: { token },
        headers: {
          Accept: 'application/json',
          Authorization: '',
        },
      })
      .then((res) => {
        if (cancelled) return;
        const data = res.data || {};
        setResult({
          status: data.state || 'success',
          title: data.title || 'Done',
          message: data.message || 'Your decision has been recorded.',
          action: data.action || null,
        });
      })
      .catch((err) => {
        if (cancelled) return;
        const data = err.response?.data;
        if (data && data.title) {
          setResult({
            status: data.state || 'error',
            title: data.title,
            message: data.message || 'Could not complete this leave decision.',
            action: data.action || null,
          });
          return;
        }
        setResult({
          status: 'error',
          title: 'Something went wrong',
          message: 'Could not complete this leave decision. Please try again.',
          action: null,
        });
      });

    return () => {
      cancelled = true;
    };
  }, [searchParams]);

  return (
    <div className="auth-page min-h-screen flex items-center justify-center bg-secondary-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="w-full max-w-md">
        <div className="bg-white border border-secondary-200 rounded-2xl shadow-sm px-8 py-10 text-center">
          <div className="flex justify-center mb-5">{iconFor(result.status, result.action)}</div>
          <h1 className="text-xl font-bold text-secondary-900 tracking-tight">{result.title}</h1>
          <p className="mt-3 text-sm text-secondary-600 leading-relaxed">{result.message}</p>
        </div>
      </div>
    </div>
  );
};

export default LeaveEmailAction;
